import React from 'react';
import { Car, Users, Globe, Shield } from 'lucide-react';

export default function About() {
  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-4xl mx-auto space-y-16">
        {/* Hero Section */}
        <div className="text-center space-y-4">
          <h1 className="text-3xl md:text-4xl font-bold text-white">
            Hakkımızda
          </h1>
          <p className="text-gray-400 text-lg">
            Türkiye'nin en büyük taksi durağı platformu
          </p>
        </div>

        {/* Mission & Vision */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-white/5">
            <div className="flex items-start gap-4">
              <div className="p-3 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-xl shadow-lg shadow-yellow-400/20">
                <Globe className="w-6 h-6 text-gray-900" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-white mb-2">
                  Misyonumuz
                </h3>
                <p className="text-gray-400">
                  Yolcular ve taksi durakları arasında güvenilir bir köprü kurarak, 
                  ulaşımı daha kolay ve erişilebilir hale getirmek.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-white/5">
            <div className="flex items-start gap-4">
              <div className="p-3 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-xl shadow-lg shadow-yellow-400/20">
                <Car className="w-6 h-6 text-gray-900" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-white mb-2">
                  Vizyonumuz
                </h3>
                <p className="text-gray-400">
                  Türkiye'nin her şehrinde, her an ulaşılabilir ve güvenilir taksi 
                  hizmetini herkes için mümkün kılmak.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-4 text-center border border-white/5">
            <div className="text-2xl font-bold text-yellow-400">81</div>
            <div className="text-sm text-gray-400">İl</div>
          </div>
          <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-4 text-center border border-white/5">
            <div className="text-2xl font-bold text-yellow-400">922</div>
            <div className="text-sm text-gray-400">İlçe</div>
          </div>
          <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-4 text-center border border-white/5">
            <div className="text-2xl font-bold text-yellow-400">32,000+</div>
            <div className="text-sm text-gray-400">Mahalle</div>
          </div>
          <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-4 text-center border border-white/5">
            <div className="text-2xl font-bold text-yellow-400">18,000+</div>
            <div className="text-sm text-gray-400">Taksi Durağı</div>
          </div>
        </div>

        {/* Values */}
        <div>
          <h2 className="text-2xl font-bold text-white text-center mb-8">
            Değerlerimiz
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-white/5">
              <div className="flex flex-col items-center text-center gap-4">
                <div className="p-3 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-xl shadow-lg shadow-yellow-400/20">
                  <Shield className="w-6 h-6 text-gray-900" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-white mb-2">
                    Güvenlik
                  </h3>
                  <p className="text-gray-400">
                    Yolcularımızın ve sürücülerimizin güvenliği her zaman önceliğimizdir.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-white/5">
              <div className="flex flex-col items-center text-center gap-4">
                <div className="p-3 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-xl shadow-lg shadow-yellow-400/20">
                  <Users className="w-6 h-6 text-gray-900" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-white mb-2">
                    Güvenilirlik
                  </h3>
                  <p className="text-gray-400">
                    Şeffaf ve dürüst hizmet anlayışıyla çalışıyoruz.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-white/5">
              <div className="flex flex-col items-center text-center gap-4">
                <div className="p-3 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-xl shadow-lg shadow-yellow-400/20">
                  <Globe className="w-6 h-6 text-gray-900" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-white mb-2">
                    Erişilebilirlik
                  </h3>
                  <p className="text-gray-400">
                    Herkes için kolay ve hızlı ulaşım çözümleri sunuyoruz.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}